<template>
    <v-dialog v-model="showDialog" max-width="500" scrollable>
        <v-card>
            <v-card-title class="headline flex-column pa-2">
                <div class="d-flex fill-width">
                    <div class="flex-grow-1">{{ title }}</div>
                    <v-btn icon @click="closeDialog" class="float-right"><v-icon>mdi-close</v-icon></v-btn>
                </div>
            </v-card-title>

            <v-card-text class="d-flex align-center justify-center" v-if="loading">
                <v-progress-circular indeterminate size="32"></v-progress-circular>
            </v-card-text>
            <template v-else>
                <v-card-text>
                    <v-form v-model="formValid">
                        <v-row>
                            <v-col cols="12" md="6">
                                <form-field v-model="eventTypeField.value" :field="eventTypeField" star ></form-field>
                                <div v-if="timePeriods && !oneMatch">
                                    <v-divider></v-divider>
                                    <form-field  v-model="timePeriodField.value" :field="timePeriodField"></form-field>
                                </div>
                                <div v-if="oneMatch">
                                    <v-divider></v-divider>
                                    <form-field v-model="resultTypeField.value" :field="resultTypeField" star></form-field>
                                </div>
                            </v-col>
                            <v-divider vertical class="hidden-sm-and-down"></v-divider>
                            <v-col cols="12" md="6">
                                <div v-if="!oneMatch">
                                    <form-field v-model="teamField.value" :field="teamField" star></form-field>
                                    <form-field v-model="playerField.value" :field=playerField v-if="!isIndividualCompetition"></form-field>
                                    <form-field v-model="matchTimeField.value" :field="matchTimeField"></form-field>
                                    <form-field v-model="commentField.value" :field="commentField"></form-field>
                                    <form-field v-if="showUpdateResultCheckbox" v-model="updateResultField.value" :field="updateResultField"></form-field>
                                </div>
                                <div v-else>
                                    <form-field v-model="resultField.value" :field="resultField"></form-field>
                                </div>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-end">
                    <v-btn class="zoezi-button-thin mb-2" @click="remove" color="error" v-if="eventId && !oneMatch">{{ $translate('Remove') }}</v-btn>
                    <v-spacer />
                    <v-btn class="zoezi-button-thin mb-2" @click="closeDialog">{{ $translate('Cancel') }}</v-btn>
                    <v-btn v-if="!eventId || oneMatch" class="zoezi-button-thin mb-2 mr-2 primarytext--text" color="primary" :disabled="!formValid"  @click="save" :loading="saving">{{$translate('Save')}}</v-btn>
                    <v-btn v-else class="zoezi-button-thin mb-2 primarytext--text" color="primary" :disabled="!formValid" @click="change" :loading="changing">{{$translate('Change')}}</v-btn>
                </v-card-actions>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
import FormField from '../components/FormField.vue';
import { resultRules } from '../util';
export default {

    name: 'zoezi-teamsport-event-dialog',

    components: {
        FormField,
    },

    props: {
        value: {
            type: Boolean,
            default: false,
        },
        match: {
            type: Object,
            required: true,
        },
        teamId: {
            type: Number,
        },
        eventId: {
            type: Number,
        },
        eventTypeId: {
            type: Number,
        },
        oneMatch: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            loadingInvalidResults: false,
            loadingEvents: false,
            loadingMembers: false,
            loadingTeamsportAndEventTypes: false,
            formValid: false,
            saving: false,
            changing: false,
            events: [],
            invalidResults: [],
            eventTypes: [],
            unsubscribe: [],
            teamsport: null,
            members: [],
            teamField: {
                name: 'team',
                title: 'Team',
                type: 'select',
                required: true,
                data: [],
                value: '',
            },
            eventTypeField: {
                name: 'eventType',
                title: 'Event type',
                type: 'radiogroup',
                required: true,
                value: null,
            },
            resultTypeField: {
                name: 'resultType',
                title: 'Result type',
                type: 'radiogroup',
                required: true,
                value: null,
            },
            resultField: {
                name: 'result',
                title: 'Result',
                type: 'text',
                value: '',
            },
            updateResultField: {
                name: 'updateResult',
                title: 'Update result',
                type: 'checkbox',
                value: false,
            },
            matchTimeField: {
                name: 'matchTime',
                title: 'Match time',
                type: 'text',
                value: '',
            },
            timePeriodField: {
                name: 'timePeriod',
                title: 'Time period',
                type: 'radiogroup',
                value: '',
            },
            playerField: {
                name: 'player',
                title: 'Player',
                type: 'select',
                value: '',
                data: [],
            },
            commentField: {
                name: 'comment',
                title: 'Comment',
                type: 'text',
                value: '',
            },
        };
    },

    watch: {
        eventId: {
            handler(val) {
                if (val) {
                    this.setEvent(val);
                }
            }
        },
        eventTypeId: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.eventTypeField.value = val;
                }
            }
        },
        teamId: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.teamField.value = val;
                }
            }
        },
        match: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.getMembersInMatch();
                    this.teamField.data = this.match.teams.map(team => ({ value: team.id, text: team.name }));
                    this.teamField.title = this.isIndividualCompetition ? 'Player' : 'Team';
                }
            }
        },
        'teamField.value': {
            immediate: true,
            handler() {
                this.playerField.data = this.getAvailablePlayers();
            }
        },
    },

    computed: {
        showDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        teamsportAndEventTypes() {
            return { teamsport: this.teamsport, eventTypes: this.eventTypes };
        },
        timePeriods() {
            return this.teamsport?.timeperiods?.split(',').map(option => option.trim());
        },
        eventTypesForSport() {
            return this.eventTypes?.filter(et => this.teamsport?.eventtypes?.find(teamsportEventType => teamsportEventType == et.id)).sort((a, b) => a.name.localeCompare(b.name));
        },
        showUpdateResultCheckbox() {
            return this.eventTypesForSport?.find(et => this.eventTypeField?.value == et.id)?.points > 0;
        },
        invalidResultsData() {
            return this.invalidResults.map(result => ({ value: result.id, text: result.name }));
        },
        title() {
            if (!this.oneMatch) {
                return this.$translate(this.eventId ? 'Change event' : 'Add event');
            } else {
                const team = this.match?.teams.find(team => team.id == this.teamId);
                const result = this.match?.result?.find(r => r.team_id == this.teamId)?.result;
                if (!team) {
                    return this.$translate('Add result');
                }
                return result
                    ? this.$translate('Change result for {0}').format(team.name)
                    : this.$translate('Add result for {0}').format(team.name);
            }
        },
        loading() {
            return this.loadingInvalidResults || this.loadingEvents || this.loadingTeamsportAndEventTypes || this.loadingMembers;
        },
        isIndividualCompetition() {
            return this.match.division.competitionstep.gameclass.individual;
        }
    },

    methods: {
        getTeamsportAndEventTypes() {
            this.loadingTeamsportAndEventTypes = true;
            Promise.all([
                this.getTeamsport(),
                this.getEventTypes(),
            ]).then(() => {
                const filteredEventTypes = this.eventTypes.filter(et =>
                    this.teamsport.eventtypes.includes(et.id)
                );

                const sortedEventTypes = filteredEventTypes.sort((a, b) =>
                    a.name.localeCompare(b.name)
                );

                this.eventTypeField.data = sortedEventTypes.map(event => ({
                    value: event.id,
                    text: event.name
                }));

                this.timePeriodField.data = this.teamsport?.timeperiods?.split(',').map(option => ({ value: option, text: option }));
                this.loadingTeamsportAndEventTypes = false;
            });
        },
        getAvailablePlayers() {
            if (this.oneMatch) {
                return [];
            }
            if (!this.match || !this.teamField.value){
                return [];
            }
            const index = this.match.teams.findIndex(team => team.id == this.teamField.value);
            if (index == -1) {
                return [];
            }
            return this.getUsers(index).map(player => ({ value: player.id, text: player.name }));
        },
        possiblyShowError(response) {
            if (!response.ok) {
                response.json().then(data => {
                    this.$store.commit('showErrorDialog', { title: this.$translate('Error'), text: `${this.$translate('Something went wrong')}. ${this.$translate(data?.message)}`});
                });
            }
        },
        setEvent() {
            if (this.oneMatch) {
                this.event = this.events.find(event => event.team_id == this.teamId);
            } else {
                this.event = this.events.find(event => event.id == this.eventId);
            }

            if (!this.event) {
                return;
            }
            this.eventTypeField.value = this.event.eventtype_id;
            this.teamField.value = this.event.team_id;
            this.playerField.value = this.event.user_id;
            this.matchTimeField.value = this.event.matchtime;
            this.timePeriodField.value = this.event.timeperiod;
            this.commentField.value = this.event.comment;
        },
        getUsers(index) {
            if (!this.match || !this.members?.length) {
                return [];
            }
            return this.match.team_activities[index]?.bookings?.map(booking => {
                const user = this.members.find(x => x.id == booking.user_id);
                return {
                    name: user.name,
                    id: user.id,
                }
            }).sort((a, b) => a.name.localeCompare(b.name));
        },
        getTeamsport() {
            return this.$api.get('/api/teamsport/get',{id: this.match.teamsport_id}).then(response => {
                this.teamsport = response;
            });
        },
        getMembersInMatch() {
            this.loadingMembers = true;
            this.$api.get('/api/memberapi/teamsport/get_member_in_match', {match_id: this.match.id}).then(members => {
                this.members = members;
                this.playerField.data = this.getAvailablePlayers();
                this.loadingMembers = false;
            })
        },
        setResult() {
            const result = this.match?.result?.find(r => r.team_id == this.teamId)
            if (!result) {
                this.resultTypeField.value = null;
            } else {
                this.resultField.value = result.result
                this.resultTypeField.value = result.invalid_id ? result.invalid_id: 0; // Valid result = 0
            }
            this.resultField.rules = resultRules(this.match?.result_type);
        },
        getErrorMessage(resultType, example) {
            return example
                ? this.$translate('Allowed format: {0}, Ex: {1}').format(this.$translate(resultType), example)
                : this.$translate('Allowed format: {0}').format(this.$translate(resultType));
           
        },
        getEventTypes() {
            return this.$api.get('/api/teamsport/eventtype/get').then(response => {
                this.eventTypes = response;
            });
        },
        getInvaldResults() {
            this.loadingInvalidResults = true;
            this.$api.get('/api/teamsport/resultinvalid/get').then(response => {
                response.unshift({id: 0, name: this.$translate('Valid result')});
                this.invalidResults = response;
                this.resultTypeField.data = this.invalidResultsData,
                this.setResult();
                this.loadingInvalidResults = false;
            });
        },
        getEvents() {
            this.loadingEvents = true;
            this.$api.get('/api/teamsport/event/get', {match_id: this.match.id}).then(response => {
                this.events = response;
                this.setEvent();
                this.loadingEvents = false;
            });
        },
        getResult(teamId) {
            if(!this.match.result) {
                return this.match.teams.map(team => {
                    if (team.id == teamId) {
                        return {
                            team_id: team.id,
                            result: this.resultField.value,
                            invalid_id: this.resultTypeField.value == 0 ? null : this.resultTypeField.value,
                        }
                    } else {
                        return {
                            team_id: team.id,
                            result: null,
                            invalid_id: null,
                        }
                    }
                });
            } else {
                return this.match.result.map(result => {
                    if (result.team_id == teamId) {
                        return {
                            team_id: result.team_id,
                            result: this.resultField.value,
                            invalid_id: this.resultTypeField.value == 0 ? null : this.resultTypeField.value,
                        }
                    } else {
                        return result;
                    }
                });
            }
        },
        save() {
            this.saving = true;
            let postData = null;
            let url = null;
            if(this.oneMatch) {
                if (!this.eventTypeField.value) {
                    url = '/api/teamsport/match/setresult';
                    postData = {
                        match_id: this.match.id,
                        result: this.getResult(this.teamId),
                        finished: false
                    }
                } else {
                    url = '/api/teamsport/event/add';
                    postData = {
                        match_id: this.match.id,
                        eventtype_id: this.eventTypeField.value,
                        team_id: this.teamId,
                        result: this.resultField.value,
                    }
                if (this.resultTypeField.value != 0) {
                    postData.invalid_id = this.resultTypeField.value;
                }
            }
            } else {
                url = '/api/teamsport/event/add';
                postData = {
                    match_id: this.match.id,
                    eventtype_id: this.eventTypeField.value,
                    team_id: this.teamField.value,
                    matchtime: this.matchTimeField.value,
                    user_id : this.playerField.value,
                    comment: this.commentField.value,
                    timeperiod: this.timePeriodField.value,
                }
                if (this.showUpdateResultCheckbox) {
                    postData.update_result = this.updateResultField.value;
                }
            }
            this.$api.post(url, postData).then((data) => {
                this.saving = false;
                this.closeDialog();
                this.possiblyShowError(data);
            });
        },
        change() {
            this.changing = true;
            let postData = {
                id: this.eventId,
                eventtype_id: this.eventTypeField.value,
                team_id: this.teamField.value,
                matchtime: this.matchTimeField.value,
                user_id : this.playerField.value,
                comment: this.commentField.value,
                timeperiod: this.timePeriodField.value,
            }
            if (this.showUpdateResultCheckbox && this.updateResult) {
                postData.update_result = this.updateResultField.value;
            }
            this.$api.post('/api/teamsport/event/change', postData).then((response) => {
                this.changing = false;
                this.closeDialog();
                this.possiblyShowError(response);
            });
        },
        remove() {
            this.removing = true;
            let postData = {
                id: this.eventId,
            }
            if (this.showUpdateResultCheckbox) {
                postData.update_result = this.updateResultField.value;
            }
            this.$api.post('/api/teamsport/event/remove', null, postData).then((response) => {
                this.removing = false;
                this.closeDialog();
                this.possiblyShowError(response);
            });
        },
        closeDialog() {
            this.showDialog = false;
        },
    },

    mounted() {
        this.unsubscribe.push(this.$api.subscribe({type: 'teamsport', callback: (_, event) => {
            if (this.teamsport && event.data.find(x => x.id == this.teamsport.id)) {
                this.this.getTeamsportAndEventTypes();
            }
        }}))

        this.unsubscribe.push(this.$api.subscribe({
            type: 'teamsporteventtype',
            callback: () => this.getTeamsportAndEventTypes()
        }));

        this.unsubscribe.push(this.$api.subscribe({
            type: 'teamsportresultinvalid',
            callback: () => this.getInvaldResults()
        }));

        this.unsubscribe.push(this.$api.subscribe({
            type: 'teamsportevent',
            callback: () => this.getEvents()
        }));

        this.getTeamsportAndEventTypes();
        this.getInvaldResults();
        this.getEvents();
    },

    destroyed() {
        this.unsubscribe?.forEach(unsubscribe => unsubscribe());
    },
}
</script>